import { Card } from '@packages/ui/base/card/card';

export const AffiliateDisclosureCard = () => {
  return (
    <Card>
      <div className="text-muted-foreground mx-auto max-w-2xl space-y-4 text-sm">
        <p>
          Wishlists may contain affiliate links from partners like Amazon. We earn a comission from
          qualifying purchases at no extra cost to you.
        </p>
        <p>
          We keep this privacy-first: our affiliate links do not allow us to identify you, see
          personal information about you, or follow you around the web.
        </p>
      </div>
    </Card>
  );
};
